'use client';
import { useEffect, useState } from 'react';

import { getUVEState } from '@dotcms/uve';

import customRenderers from '.';

/**
 * Renders a dev-only fallback when no renderer is registered for a content type.
 */
const DefaultContent = ({ contentType }) =>
    process.env.NODE_ENV === 'development' ? (
        <div className="rounded border border-dashed border-yellow-400 bg-yellow-50 px-4 py-3 text-sm text-yellow-800">
            Content type renderer not found: <strong>{contentType ?? 'unknown'}</strong>
        </div>
    ) : null;

/**
 * Renders a DotContent component.
 *
 * @param {DotContentProps} props - The props for the DotContent component.
 * @returns {JSX.Element} The rendered DotContent component.
 */
export const DotContent = ({ node, ...props }) => {
    const [insideEditor, setInsideEditor] = useState(false);

    const { attrs } = node ?? {};
    const data = attrs?.data;

    // We import the customRenderers from the index.js
    // Because the `DotContent` component not have access to the customRenderers
    // Note: Should we send the customRenderers as a prop to in the SDK?
    const Component = customRenderers?.[data?.contentType];

    useEffect(() => {
        if (!Component) {
            console.warn(`DotContent: No component found for content type: ${data?.contentType}`);
        }

        if (!data) {
            console.warn('DotContent: No data provided');
        }

        setInsideEditor(!!getUVEState());
    }, [Component, data]);

    if (!Component) {
        return <DefaultContent contentType={data?.contentType} />;
    }

    return <Component node={node} {...props} />;
};
